var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanderaChile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.99 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__cls-1{fill:#f0f0f0}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Chile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Trazado_3551",
    "data-name": "Trazado 3551",
    className: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__cls-1",
    d: "M0 0h23v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Trazado_3552",
    "data-name": "Trazado 3552",
    d: "M0 8h23v8H0z",
    fill: "#d60f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Trazado_3553",
    "data-name": "Trazado 3553",
    d: "M0 0h7.66v8H0z",
    fill: "#1e56a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__Trazado_3554",
    "data-name": "Trazado 3554",
    className: "bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__bandera-Chile_svg__cls-1",
    d: "M6.45 3.42l-2 .05-.62-1.95-.59 2-2-.05 1.63 1.14-.66 1.88 1.62-1.12 1.62 1.12-.66-1.88z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaChile);
export default __webpack_public_path__ + "static/media/bandera-Chile.7412cc01.svg";
export { ForwardRef as ReactComponent };